import FilesGrid from './FilesGrid'
export * from './FilesGrid'

export default FilesGrid
